import React, { useState } from "react";
import { CCol, CLink, CRow, CWidgetStatsC, CWidgetStatsD } from "@coreui/react";
import { Link } from "react-router-dom";

import activeOrderIcon from "src/assets/icons/active-order.png";
import delieveredOrderIcon from "src/assets/icons/delivered-order.png";
import allOrderIcon from "src/assets/icons/all-orders.png";

const WidgetsF = ({ data }) => {
  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  return (
    <>
      <div className="d-md-flex flex-sm-wrap justify-content-between h-100">
        <Link
          to="/manage-booking-orders"
          className="text-decoration-none"
          style={{
            color: "black",
            flexBasis: "19%",
            minWidth: "150px",
          }}
        >
          <CWidgetStatsC
            className="dashboard-card"
            icon={
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  style={{
                    fontSize: "32px",
                    color: "rgba(44, 56, 74, 0.95)",
                    fontWeight: 500,
                  }}
                >
                  {data?.totalBookingOrders ? data.totalBookingOrders : 0}
                </h1>
                <img src={allOrderIcon} width="40" />
              </div>
            }
            progress={{
              color: "damas-blue",
              value: 100,
            }}
            title={
              <span
                style={{
                  fontSize: "12px",
                  color: "rgba(44, 56, 74, 0.95)",
                  fontWeight: 400,
                }}
              >
                Total Booking Orders
              </span>
            }
          />
        </Link>
        <Link
          to="/manage-booking-orders?status=active"
          className="text-decoration-none"
          style={{
            color: "black",
            flexBasis: "19%",
            minWidth: "150px",
          }}
        >
          <CWidgetStatsC
            className="dashboard-card"
            icon={
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  style={{
                    fontSize: "32px",
                    color: "rgba(44, 56, 74, 0.95)",
                    fontWeight: 500,
                  }}
                >
                  {data?.ActiveBookingOrders ? data.ActiveBookingOrders : 0}
                </h1>
                <img src={activeOrderIcon} width="40" />
              </div>
            }
            progress={{ color: "damas-primary", value: 100 }}
            title={
              <span
                style={{
                  fontSize: "12px",
                  color: "rgba(44, 56, 74, 0.95)",
                  fontWeight: 400,
                }}
              >
                Active Booking Orders
              </span>
            }
          />
        </Link>
        <Link
          to="/manage-booking-orders?priority=emergency"
          className="text-decoration-none"
          style={{ color: "black", flexBasis: "19%", minWidth: "150px" }}
        >
          <CWidgetStatsC
            className="dashboard-card"
            icon={
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  style={{
                    fontSize: "32px",
                    color: "rgba(44, 56, 74, 0.95)",
                    fontWeight: 500,
                  }}
                >
                  {data?.emergencyBookingOrders
                    ? data?.emergencyBookingOrders
                    : 0}
                </h1>
                <img src={activeOrderIcon} width="40" />
              </div>
            }
            progress={{ color: "damas-grey", value: 100 }}
            title={
              <span
                style={{
                  fontSize: "12px",
                  color: "rgba(44, 56, 74, 0.95)",
                  fontWeight: 400,
                }}
              >
                Emergency Booking Orders
              </span>
            }
          />
        </Link>
        {localUser.permission.manage_trip ? (
          <Link
            to="/manage-trip"
            className="text-decoration-none"
            style={{ color: "black", flexBasis: "19%", minWidth: "150px" }}
          >
            <CWidgetStatsC
              className="dashboard-card"
              icon={
                <div className="d-flex justify-content-between align-items-center">
                  <h1
                    style={{
                      fontSize: "32px",
                      color: "rgba(44, 56, 74, 0.95)",
                      fontWeight: 500,
                    }}
                  >
                    {data?.tripMonitor ? data.tripMonitor : 0}
                  </h1>
                  <img src={activeOrderIcon} width="40" />
                </div>
              }
              progress={{ color: "damas-primary", value: 100 }}
              title={
                <span
                  style={{
                    fontSize: "12px",
                    color: "rgba(44, 56, 74, 0.95)",
                    fontWeight: 400,
                  }}
                >
                  Trip Monitor
                </span>
              }
            />
          </Link>
        ) : (
          ""
        )}
        <Link
          to="/manage-booking-orders?status=delivered"
          className="text-decoration-none"
          style={{ color: "black", flexBasis: "19%", minWidth: "150px" }}
        >
          <CWidgetStatsC
            className="dashboard-card"
            icon={
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  style={{
                    fontSize: "32px",
                    color: "rgba(44, 56, 74, 0.95)",
                    fontWeight: 500,
                  }}
                >
                  {data?.deliveredBookingOrders
                    ? data.deliveredBookingOrders
                    : 0}
                </h1>
                <img src={delieveredOrderIcon} width="40" />
              </div>
            }
            progress={{ color: "damas-secondary", value: 100 }}
            title={
              <span
                style={{
                  fontSize: "12px",
                  color: "rgba(44, 56, 74, 0.95)",
                  fontWeight: 400,
                }}
              >
                Delivered
              </span>
            }
          />
        </Link>
      </div>
    </>
  );
};

export default WidgetsF;
